import { render } from "./clock-component.vue?vue&type=template&id=377a5900"
import script from "./clock-component.vue?vue&type=script&lang=js"
export * from "./clock-component.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__